// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__5HzDS"};
module.exports.__checksum = "baaae5ec6d5c"
